import { Context } from "../../index";
import { Button } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { FaArrowUpRightDots } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { PAY_ROUTE } from "../../utils/consts";

const SortAssignsG = observer(() => {
    const { book, user } = useContext(Context);
    const [isPressed, setIsPressed] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const navigate = useNavigate();

    const isFreeTariff = user?.user?.tariff_plan === "FREE";
    const registeredDaysAgo =
        (Date.now() - new Date(user?.user?.registration_date * 60_000).getTime()) /
        (1000 * 60 * 60 * 24);
    const isFreeAllowed = isFreeTariff && registeredDaysAgo <= 30;
    const isSortingAllowed = !isFreeTariff || isFreeAllowed;
    const [isHoveredVirt, setIsHoveredVirt] = useState(false);

    const handleSortClick = () => {
        if (!isSortingAllowed) {
            setShowTooltip(true);
            return;
        }

        const newState = !isPressed;
        setIsPressed(newState);
        book.setSortAssignments(newState);
    };

    return (
        <div className="position-relative">
            <div className="d-flex flex-wrap justify-content-start">
                <Button
                    title="Sort Assignments by Price in Virt"
                    variant={isPressed ? "success" : "outline-success"}
                    className="mx-1 d-flex btn-sm align-items-center fw-semibold"
                    style={{
                        transition: "transform 0.2s",
                        transform: isHoveredVirt ? "scale(1.1)" : "scale(1)",
                        width: "80px",
                        whiteSpace: "nowrap",
                        opacity: isSortingAllowed ? 1 : 0.6,
                        cursor: isSortingAllowed ? "pointer" : "not-allowed",
                    }}
                    onMouseEnter={() => setIsHoveredVirt(true)}
                    onMouseLeave={() => setIsHoveredVirt(false)}
                    onClick={handleSortClick}
                >
                    <FaArrowUpRightDots className="me-2" />
                    Virt Up
                </Button>
            </div>

            {showTooltip && (
                <div
                    style={{
                        position: "absolute",
                        top: "40px",
                        left: "0",
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "12px",
                        borderRadius: "8px",
                        zIndex: 100,
                        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                        width: "260px"
                    }}
                >
                    <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                       <strong>Virt Up Sorting Feature Expired!</strong> <br />On the free plan, it's available only during your first 30 days after registration.<br />
                        Virt Up Button becomes available when you subscribe to any paid plan.


                    </p>
                    <div className="d-flex justify-content-between">
                        <button
                            onClick={() => navigate(PAY_ROUTE)}
                            className="btn btn-success btn-sm flex-grow-1 me-1"
                        >
                            Get Subscription
                        </button>
                        <button
                            onClick={() => setShowTooltip(false)}
                            className="btn btn-outline-success btn-sm flex-grow-1 ms-1"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
});

export default SortAssignsG;
